export default {
  error: 'Fel',
  sorry: 'Tyvärr har vi fått följande fel',
  workingOnIt:
    'En ingenjör har fått meddelande om detta problem och vi arbetar för att lösa det så snabbt som möjligt.',
  tryAgain: 'Vänligen försök igen senare',
  noInternet:
    'Det verkar vara ett problem med din internetanslutning. Kontrollera och försök igen.',
}
